import React, { useState } from 'react';
import CareerModal from './CareerModal';

const careerHistory = [
    {
        id: 1,
        title: "Software Engineer",
        company: "ReeceTech.",
        duration: "Nov 2023 - Present",
        location: "Melbourne, VIC",
        shortDescription: "Point Of Sales Team at ReeceTech which operates as an internal S.A.A.S platform.",
        description: "Currently working on a custom point of Sales system, designed specifically for Reece. This team runs as a S.A.A.S platform, providing a frontend for users and API for other teams, such a digital experiences, to allow the creation of sales orders.",
        achievements: [
            "Create API's that offer seamless integration with other Reece Application, both internal and External.",
            "Ensure data integrity and consistency with orders with multiple consignments, across multiple systems.",
            "Work directly with the end users to develop features they need.",
            "Develop secure third-party access to our applications using Cloud Technologies, ensuring secure and seamless integration.",
            "Designed the Solution for processing and uploading large amounts of data to the 3rd party in real-time.",
            "Champion meaningful Agile practices, driving improvements to ceremonies and teamwork.",
            "Mentoring Junior Staff and IBL students with one-on-one sessions and peer programming sessions.",
        ],
        technologies: ["Java", "Javascript", "React", "Angular", "SQL", "AWS"],
        accent: "emerald",
    },
    {
        id: 2,
        title: "Associate Software Engineer",
        company: "ReeceTech",
        duration: "Nov 2022 - Nov 2023",
        location: "Melbourne, VIC",
        shortDescription: "Full-stack development in an enterprise environment.",
        description: "Upon completion of my studies, I transitioned into a full time role as a associate software engineer. I worked across two teams during this stage, supplychain team and platforms engineering.",
        achievements: [
            "Automate data integrity checks between systems, reducing manual interventions and enhancing system stability.",
            "Developed a 2FA-secured admin application that eliminated credential sharing risks and provided controlled methods to fix data corruption with built-in safeguards.",
            "Created real-time deployment notification system connecting GitHub pipelines to messaging applications, enabling configurable alerts.",
            "Led cloud migration for a key on-premises application, which included improving the reliability of the upgrade and deployment as well as usability of the application through easy-to-use interfaces designed for non-technical users.",
        ],
        technologies: ["Java", "Javascript", "React", "Angular", "SQL", "AWS", "GoLang"],
        accent: "sky",
    },
    {
        id: 3,
        title: "Study + Associate Software Engineer (Part Time)",
        company: "ReeceTech",
        duration: "Jan 2022 - Nov 2022",
        location: "Melbourne, VIC",
        shortDescription: "First exposure to professional software development.",
        description: "Started an upskilling course, sponsored by my workplace to transition into a career in Tech. This was completed alongside working one day a week in the office with a development team.",
        achievements: [
            "Completed daily/weekly coding tasks that started with the C programming Language and progressed to Python and Web development, including server side Infrastructure as Code.",
            "While studying, I worked one day a week with a development team, contributing to development projects while maintaining academic excellence and expanding technical knowledge base.",
            "Fortnightly meeting with a mentor to bridge the gap between classroom learning and real world application of the skills.",
        ],
        technologies: ["C", "Python", "Git", "MySQL", "Bash", "Flask"],
        accent: "violet",
    },
    {
        id: 4,
        title: "Assistant Manager",
        company: "Reece Group",
        duration: "2020 - 2022",
        location: "Ballarat, VIC",
        shortDescription: "Assistant Manager for various Reece Stores across Victoria.",
        description: "Was responsible for assisting the Store Manager of various Reece Stores to drive sales and manage staff.",
        achievements: [
            "Drove store profitability from $250K to $400K monthly while reducing staff turnover to just one new hire annually through strategic recruitment and effective training programs.",
            "Led the implementation of head office directives, ensuring clear communication channels between management and staff while supporting store growth.",
            "Led Sales meetings with prospective and existing customers.",
            "Engaged in customer relationship building activities to drive sales, customer engagement, and retention.",
            "Fostered team cohesion through mentorship programs that directly contributed to reduced turnover rates and enhanced store performance metrics.",
        ],
        technologies: ["People Management", "Financial Forecasting", "Sales (B2B and B2C)"],
        accent: "amber",
    },
    {
        id: 5,
        title: "Counter Hand",
        company: "Reece Group",
        duration: "July 2018 - 2020",
        location: "Docklands, VIC",
        shortDescription: "Working at the trade counter, assisting plumbers and customers with their orders and queries.",
        description: "My first role at Reece was working at the trade counter, assisting plumbers and customers with their orders and queries. This role was very customer focused and required me to learn about the products we sold to be able to assist customers effectively.",
        achievements: [],
        technologies: [],
        accent: "rose",
    },
    {
        id: 6,
        title: "Outbound Sales Representative",
        company: "Red Energy",
        duration: "Jan 2018 - July 2018",
        location: "Cremorne, VIC",
        shortDescription: "Outbound sales for residential and small business energy customers.",
        description: "Responsible for outbound sales calls to prospective residential and small business customers, pitching energy plans and handling objections in a high-volume call centre environment.",
        achievements: [],
        technologies: [],
        accent: "teal",
    },
    {
        id: 7,
        title: "Assistant Store Manager",
        company: "Aldi",
        duration: "2016 - Jan 2018",
        location: "VIC",
        shortDescription: "Assistant Manager at various Aldi Stores across Victoria.",
        description: "Was responsible for assisting the Store Manager in the day to day operations of the supermarket, including people management, stock management and store operations.",
        achievements: [],
        technologies: [],
        accent: "violet",
    },
    {
        id: 8,
        title: "Assistant Restaurant Manager",
        company: "Hungry Jacks",
        duration: "2015 - 2016",
        location: "Ballarat, VIC",
        shortDescription: "Assistant Restaurant Manager at a Ballarat Based Hungry Jacks store.",
        description: "Was responsible for assisting the Restaurant Manager in the day to day operations of the restaurant, including people management, stock management and restaurant operations. Ensuring Food Quality and Safety standards were met was a key part of this role.",
        achievements: [],
        technologies: [],
        accent: "rose",
    },
    {
        id: 9,
        title: "Bakery Production Manager",
        company: "Modern Day Bakery",
        duration: "2014 - 2015",
        location: "Daylesford, VIC",
        shortDescription: "Promoted to production manager for the bakery.",
        description: "Make the daily food products for the store, including bread, pastries and cakes. This role includes ordering stock, interviewing for positions and maintaining the bakery standards of food safety and cleanliness.",
        achievements: [],
        technologies: [],
        accent: "teal",
    },
    {
        id: 10,
        title: "Qualified Baker + Pastry Chef",
        company: "Modern Day Bakery",
        duration: "2012 - 2014",
        location: "Daylesford, VIC",
        shortDescription: "After finishing my apprenticeship a year early, continued as a qualified baker.",
        description: "Make the daily food products for the store, including bread, pastries and cakes. This role also included training apprentice bakers.",
        achievements: [],
        technologies: [],
        accent: "amber",
    },
    {
        id: 11,
        title: "Apprentice Baker + Pastry Chef",
        company: "Modern Day Bakery",
        duration: "2010 - 2012",
        location: "Daylesford, VIC",
        shortDescription: "First job out of high school — apprentice baker working up to qualified.",
        description: "Make the daily food products for the store, including bread, pastries and cakes. This was a very physical job that required me to work in a team to meet the demands of the store and customers.",
        achievements: [],
        technologies: [],
        accent: "pink",
    },
];

export default function CareerTimeline() {
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleCardClick = (position) => {
        setSelectedPosition(position);
        setIsModalOpen(true);
    };

    return (
        <>
            <div className="timeline-career-wrap">
                <div className="timeline-spine" />
                {careerHistory.map((position, index) => (
                    <div
                        key={position.id}
                        className={`timeline-row accent-${position.accent} ${index % 2 === 0 ? 'row-left' : 'row-right'}`}
                    >
                        <div className="timeline-node" />
                        <div
                            className="timeline-card"
                            onClick={() => handleCardClick(position)}
                        >
                            <div className="tl-card-hd">
                                <div className="tl-card-chip">
                                    {position.company.charAt(0)}
                                </div>
                                <div className="tl-card-meta">{position.duration}</div>
                            </div>
                            <h3>{position.title}</h3>
                            <div className="tl-card-org">{position.company}</div>
                            <p>{position.shortDescription}</p>
                            <span className="link-arrow">View details →</span>
                        </div>
                    </div>
                ))}
            </div>

            <CareerModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                position={selectedPosition}
            />
        </>
    );
}
